import * as actionTypes from '../actions/actionTypes';
import {updateObject, cloneObject} from "../../shared/utility";

const getDarkModeFromStorage = () => {
    if (localStorage.getItem('darkMode')) {
        return localStorage.getItem('darkMode') === 'true'
    } else {
        return true;
    }
}

const initialState = {
    stateMessage: null,
    darkMode: getDarkModeFromStorage(),
    selectedVehicleIndex: null,
    selectedVehicle: null,
    loading: false,
    qualifyVehicle: {
        loading: null,
        error: null
    }
}

const setStateLoading = (state, action) => {
    return updateObject(state, {
        loading: !!action.loading
    });
}

const setStateMessage = (state, action) => {
    return updateObject(state, {stateMessage: action.message})
}

const setDarkMode = (state, action) => {
    return updateObject(state, {darkMode: action.darkMode})
}

const setSelectedVehicle = (state, action) => {
    return updateObject(state, {
        selectedVehicleIndex: action.index,
        selectedVehicle: action.vehicles ? action.vehicles[action.index] : null
    })
}

const setData = (state, action) => {
    const updatedState = cloneObject(action.data)
    return updateObject(state, updatedState);
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_APP_SELECTED_VEHICLE:
            return setSelectedVehicle(state, action);
        case actionTypes.SET_APP_STATE_MESSAGE:
            return setStateMessage(state, action);
        case actionTypes.SET_APP_DARK_MODE:
            return setDarkMode(state, action);
        case actionTypes.SET_APP_LOADING:
            return setStateLoading(state, action);
        case actionTypes.SET_APP_DATA:
            return setData(state, action);
        default:
            return state;
    }
};

export default reducer;